import React, { FC } from 'react';
import { PiecefulProvider } from 'react-pieceful-state';

const EditAssetProvider: FC = ({ children }) => {
  return <PiecefulProvider region="editAsset">{children}</PiecefulProvider>;
};

export default EditAssetProvider;
